import React from 'react';
import parse from 'date-fns/parse';
import PropTypes from 'prop-types';

// Utils
import { formatTime } from 'utils/date';

import './DateFooter.scss';

const DateFooter = ({ intl, date, scheduledInfo = false, text = '' }) => {
  if (!date) {
    return null;
  }
  const parsedDate = parse(date);
  const ns = DateFooter.block;
  return !scheduledInfo ? (
    <div className={ns}>
      <div className="date">
        {intl.formatDate(parsedDate, {
          weekday: 'short',
          month: 'short',
          day: 'numeric'
        })}
      </div>
      <div className="time">{formatTime(parsedDate, intl, false, false)}</div>
    </div>
  ) : (
    <div className={ns}>
      <span>{text} </span>
      <span>
        {intl.formatDate(parsedDate, {
          weekday: 'short',
          month: 'short',
          day: 'numeric'
        })}
      </span>
      <span className={`${ns}__time--no-scheduled-info`}>
        {' '}
        {formatTime(parsedDate, intl, false, false)}
      </span>
    </div>
  );
};

DateFooter.block = 'date-footer';

DateFooter.propTypes = {
  date: PropTypes.instanceOf(Date),
  intl: PropTypes.object,
  scheduledInfo: PropTypes.bool,
  text: PropTypes.string
};
export default DateFooter;



// WEBPACK FOOTER //
// ./src/components/atoms/DateFooter/DateFooter.js